import type { MerchantId } from "~~/shared/types/common.interfaces";

const MERCHANT_IDS = new Set<MerchantId>([
  "elemental-raiders",
  "jump-pump",
  "soccer-legends",
  "diamond-dreams",
  "dead-zombie",
  "meme-rings",
  "proof-of-luxe",
]);

export const isMerchantId = (
  value: string | null | undefined
): value is MerchantId => typeof value === "string" && MERCHANT_IDS.has(value as MerchantId);
